export const CookieManager = {
  clearAll: () => Promise.resolve(),
};
